export default {"src":"/_next/static/media/sync.c868f7f4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};